/*
Loons Lab Main title component
Developed By Roshan
Loons Lab
*/
import React, { Component } from "react";
import { Typography } from '@material-ui/core'
import { themeColors } from 'app/components/MatxTheme/themeColors'
import { MatxLayoutSettings } from 'app/components/MatxLayout/settings'

class MainTitle extends Component {
    static propTypes = {
        title: String
    };

    static defaultProps = {
        title: null
    };



    render() {
        const {
            title
        } = this.props;
        let activeTheme = MatxLayoutSettings.activeTheme

        return (
            <Typography variant="h6" style={{color: themeColors[activeTheme].palette.subTitleTextColor}}>{title}</Typography>
        );
    }
}

export default MainTitle;